import { useRef } from "react";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { Ticker } from "@/components/site/Ticker";
import { Stats } from "@/components/site/Stats";
import { Services } from "@/components/site/Services";
import { Manifesto } from "@/components/site/Manifesto";
import { Realisations } from "@/components/site/Realisations";
import { Zones } from "@/components/site/Zones";
import { Testimonials } from "@/components/site/Testimonials";
import { QuoteForm } from "@/components/site/QuoteForm";
import { Footer } from "@/components/site/Footer";

export const DarkHome = () => {
  const quoteRef = useRef(null);
  const scrollToQuote = () => quoteRef.current?.scrollIntoView({ behavior: "smooth" });

  return (
    <div className="bg-mh-bg font-body">
      <div className="grain" />
      <Navbar onQuote={scrollToQuote} />
      <main>
        <Hero onQuote={scrollToQuote} />
        <Ticker />
        <Stats />
        <Services onQuote={scrollToQuote} />
        <Manifesto />
        <Realisations />
        <Zones />
        <Testimonials />
        <QuoteForm innerRef={quoteRef} />
      </main>
      <Footer onQuote={scrollToQuote} />
    </div>
  );
};
